import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { debounce } from "lodash";
export default {
  props: {
    keyword: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      searchResults: [],
      loading: true
    };
  },
  watch: {
    keyword: {
      handler: function handler(newVal) {
        this.search(newVal);
      }
    }
  },
  methods: {
    search: debounce(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this = this;
      var res;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.loading = true;
            _context.n = 1;
            return this.$api.advisorySearch({
              keywords: this.keyword,
              language: "zh"
            });
          case 1:
            res = _context.v;
            res.data && (this.searchResults = res.data);
            this.searchResults.forEach(function (i) {
              i.question = _this.highlightKeyword(i.question);
              i.content = i.answer;
              i.content = _this.highlightKeyword(i.content);
            });
            this.loading = false;
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    })), 300),
    selectAnswer: function selectAnswer(item) {
      this.$emit("select", item.answer, item.id);
    },
    highlightKeyword: function highlightKeyword(text) {
      var _this$keyword;
      if (!((_this$keyword = this.keyword) !== null && _this$keyword !== void 0 && _this$keyword.trim())) return text;
      var reg = new RegExp(this.keyword, "gi");
      return text.replace(reg, function (match) {
        return "<span style=\"color: #2DB6B6\">".concat(match, "</span>");
      });
    }
  }
};